import { configureStore } from "@reduxjs/toolkit";

const initialState = {
  storetoken:
    "storeToken",
  count: 0,
  storeuser: {
    //username: "",
    email: "email",
    usertype: "usertype",
    updated_at: "updatedDate",
  },
  carefacilitydetails: {},
  activeCounts: { numberofActiveUsers: "", numberofCareFaclities: "" },
  userAccessRole:"",
  //managementToken: "",
};

const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "gettoken":
      // console.log(
      //   "store get token action action is running .updated final State=",
      //   action.payload
      // );
      return { ...state, storetoken: action.payload };

    case "getuser":
      // console.log(
      //   "store get useraction action is running .updated final State=",
      //   action.payload
      // );
      return { ...state, storeuser: action.payload };

    case "UPDATE_FACILTY_DETAILS":
      return { ...state, carefacilitydetails: action.payload };

    case "UPDATE_CARE_FACILTY_LIST":
      return { ...state, carefacilitydetailslist: action.payload };

    case "UPDATE_ACTIVE_COUNTS":
      return { ...state, activeCounts: action.payload };

    // case "STORE_MGT_TOKEN":
    //   return { ...state, managementToken: action.payload };

    case "UPDATE_USER_ROLE":
      return { ...state, userAccessRole: action.payload };    

    default:
      return state;
  }
};

const store = configureStore({ reducer: globalReducer });

export default store;
